import React, { useState } from "react";
import styled from "styled-components";
import {
    AiOutlineAppstore,
    AiOutlineShoppingCart,
    AiOutlineShopping,
    AiOutlinePieChart,
    AiOutlineUsergroupAdd,
    AiOutlineMessage,
    AiOutlineLogout,
    AiOutlineUser,
    AiOutlineProduct,
    AiOutlineDown,
    AiOutlineProject,
    AiOutlineAccountBook,
    AiOutlineTool,
    AiOutlinePaperClip
} from "react-icons/ai";
import LogoutPopup from "../components/ui/LogoutPopup";
import { useNavigate } from "react-router-dom";

function Sidebar({ setCurrentPage }) {
    const [currentLink, setCurrentLink] = useState("Dashboard");
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
    const [isInvoiceDropdownOpen, setIsInvoiceDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const handlePageChange = (page) => {
        setCurrentLink(page);
        setCurrentPage(page);
    };

    // ✅ Show Logout Confirmation Popup
    const confirmLogout = () => {
        setShowLogoutPopup(true);
    };

    // ✅ Perform Logout if User Confirms
    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        setTimeout(() => {
            window.location.href = "/";
        }, 500);
    };

    return (
        <>
            <SidebarContainer>
                <div className="top">
                    <div className="brand">
                        <span>W. Thomas and Sons</span>
                    </div>
                    <div className="links">
                        <ul>
                            <li className={currentLink === "Dashboard" ? "active" : ""} onClick={() => handlePageChange("Dashboard")}>
                                <AiOutlineAppstore />
                                <span>Dashboard</span>
                            </li>

                            <li className={`dropdown ${isInvoiceDropdownOpen ? "open" : ""}`} onClick={() => setIsInvoiceDropdownOpen(!isInvoiceDropdownOpen)}>
                                <AiOutlineAccountBook />
                                <span>Finance</span>
                                <AiOutlineDown className={`dropdown-arrow ${isInvoiceDropdownOpen ? "open" : ""}`} />
                            </li>

                            {isInvoiceDropdownOpen && (
                                <ul className="submenu">
                                    <li className={currentLink === "Invoice" ? "active" : ""} onClick={() => handlePageChange("Invoice")}>
                                        <AiOutlineProject />
                                        <span>Invoice</span>
                                    </li>
                                    <li className={currentLink === "Repair" ? "active" : ""} onClick={() => handlePageChange("Repair")}>
                                        <AiOutlineTool />
                                        <span>Repairs</span>
                                    </li>
                                </ul>
                            )}

                            <li className={currentLink === "Inventory" ? "active" : ""} onClick={() => handlePageChange("Inventory")}>
                                <AiOutlineShoppingCart />
                                <span>Inventory</span>
                            </li>

                            <li
                                className={currentLink === "Products" ? "active" : ""}
                                onClick={() => handlePageChange("Products")}
                            >
                                <AiOutlineProduct />
                                <span>All Products</span>
                            </li>

                            <li className={currentLink === "Employees" ? "active" : ""} onClick={() => handlePageChange("Employees")}>
                                <AiOutlineUser />
                                <span>Employees</span>
                            </li>
                            <li className={currentLink === "Customers" ? "active" : ""} onClick={() => handlePageChange("Customers")}>
                                <AiOutlineUsergroupAdd />
                                <span>Customers</span>
                            </li>
                            <li className={currentLink === "Reports" ? "active" : ""} onClick={() => handlePageChange("Reports")}>
                                <AiOutlinePaperClip />
                                <span>Reports</span>
                            </li>
                            {/*<li className={currentLink === "Message" ? "active" : ""} onClick={() => handlePageChange("Message")}>*/}
                            {/*    <AiOutlineMessage />*/}
                            {/*    <span>Message</span>*/}
                            {/*</li>*/}
                        </ul>
                    </div>
                </div>

                {/* ✅ Show Confirmation Popup Before Logout */}
                <div className="logout" onClick={confirmLogout}>
                    <AiOutlineLogout />
                    <span>Logout</span>
                </div>
            </SidebarContainer>

            {/* ✅ Logout Confirmation Popup */}
            {showLogoutPopup && (
                <LogoutPopup
                    message="Are you sure you want to log out?"
                    onConfirm={handleLogout}
                    onClose={() => setShowLogoutPopup(false)}
                />
            )}
        </>
    );
}

export default Sidebar;

// ✅ Fix: Define the Styled Component (Use `SidebarContainer` Instead of `Section`)
const SidebarContainer = styled.section`
    position: fixed;
    left: 0;
    top: 0;
    background-color: black;
    height: 100vh;
    width: 18vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 0;
    gap: 0.6rem;
    overflow-y: auto;
    transition: all 0.3s ease-in-out;

    .top {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 1rem 0;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;

        .brand {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.4rem;
            padding: 1rem 0;

            span {
                font-size: 1.2rem;
                font-weight: bold;
                color: white;
                white-space: nowrap;
            }

            @media screen and (max-width: 768px) {
                flex-direction: column;
                span {
                    font-size: 1rem;
                }
            }
        }
    }

    .links {
        display: flex;
        justify-content: center;
        width: 100%;
        ul {
            list-style-type: none;
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 0;
            gap: 0.5rem;

            li {
                padding: 0.6rem 1.5rem;
                margin: 5px 15px;
                border-radius: 0 10px 10px 0;
                cursor: pointer;
                transition: background 0.3s, transform 0.2s;
                display: flex;
                align-items: center;
                gap: 1rem;
                font-size: 1rem;
                font-weight: 500;
                background-color: black;
                color: white;

                &:hover {
                    background-color: #333;
                    transform: scale(1.02);
                }

                &.active {
                    background-color: white;
                    color: black;
                    font-weight: bold;
                }
            }
        }
    }

    .logout {
        padding: 1rem 2rem;
        cursor: pointer;
        background-color: white;
        border-radius: 10px;
        text-align: center;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
            background-color: #ddd;
        }
    }
`;
